import * as tslib_1 from "tslib";
import { getOptionsForFeature, lazyCreateOrUpdateOptionsForFeature, OwsOptionsFeatureType, } from 'owa-outlook-service-options';
export default function saveConsentString(consentString) {
    var currentOptions = getOptionsForFeature(OwsOptionsFeatureType.GdprAdsPrefs);
    var newOptions = tslib_1.__assign({}, currentOptions, { consentString: consentString });
    return lazyCreateOrUpdateOptionsForFeature.importAndExecute(OwsOptionsFeatureType.GdprAdsPrefs, newOptions);
}
//# sourceMappingURL=saveConsentString.js.map